module.exports = __webpack_public_path__ + "onset-instructions-3.gif?4dcba102ed0abeacbe9803b6cbc4af11";